import {
  EditContext,
  EditingStoppedReason,
} from '@efdigital/ll-admin-v2/components/edit-context.gts';
import { EditLtiConsumingPlatform } from '@efdigital/ll-admin-v2/components/lti/edit-lti-consuming-platform.gts';
import { DataTypeLti } from '@efdigital/ll-admin-v2/data/data-types/lti';
import { deepRollback } from '@efdigital/ll-admin-v2/data/deep-rollback';
import type { LtiConsumingPlatform } from '@efdigital/ll-admin-v2/data/types/lti';
import { service } from '@ember/service';
import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import type { Store } from '@warp-drive/core';
import BsModal from 'ember-bootstrap/components/bs-modal';

interface Signature {
  Args: {
    clientId: string;
    onSaved: (platform: LtiConsumingPlatform) => void;
  };
  Blocks: {
    trigger: [openModal: () => void];
  };
}

export default class LtiCreatePlatformModal extends Component<Signature> {
  @service declare store: Store;

  @tracked visible = false;
  @tracked platform?: LtiConsumingPlatform;

  openModal = (): void => {
    this.platform = this.store.createRecord<LtiConsumingPlatform>(
      DataTypeLti.ConsumingPlatform,
      {
        name: '',
        description: '',
        clientId: this.args.clientId,
        platformData: { iss: 'TODO' },
      }
    );
    this.visible = true;
  };

  closeModal = (): void => {
    this.visible = false;
    this.platform = undefined;
  };

  handleEditingStopped = (reason: EditingStoppedReason) => {
    if (reason === EditingStoppedReason.Saved && this.platform) {
      this.args.onSaved(this.platform);
      this.closeModal();
      return;
    }

    if (reason !== EditingStoppedReason.Cancelled && this.platform) {
      deepRollback(this.platform, this.store);
    }

    this.closeModal();
  };

  <template>
    {{yield this.openModal to="trigger"}}
    <BsModal
      @open={{this.visible}}
      @onHidden={{this.closeModal}}
      @backdropClose={{false}}
      as |modal|
    >
      <modal.header>
        <h2 class="modal-title h5">Add LMS platform</h2>
      </modal.header>
      <modal.body>
        <p class="text-muted">
          Register the customer's LMS instance. Use
          <code>TODO</code>
          for the issuer if the customer has not provided it yet.
        </p>

        {{#if this.platform}}
          <EditContext
            @onEditingStopped={{this.handleEditingStopped}}
            as |context|
          >
            <EditLtiConsumingPlatform
              @item={{this.platform}}
              @context={{context}}
              @initialState="edit"
            />
          </EditContext>
        {{/if}}
      </modal.body>
    </BsModal>
  </template>
}
